<!-- Modal DETALLE DEL GASTO -->
<div class="modal fade" id="exampleModal2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modito" class="modal-content">
            <div class="modal-header" hidden>
                
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div class="headModal">
                    <h5 class="modal-title" id="exampleModalLabel">Gasto COD [{{ codi_edit }}]</h5>
                    <h5 style="color: red">Estado: {{estadoGasto}}</h5>
                    <h5 style="color:dimgray">Descripción: "{{ det_edit }}" </h5>
                    <h5 style="font-style: italic">Total Gasto: {{ tot_edit | currency:"$"}}</h5>    
                </div>
                
                <hr>
                <div id="tienebotones" class="col-lg-12" style="text-align: center;">
                    <div>
                        <button data-dismiss="modal" (click)="enviarCodGasto()" routerLink="/verdetalles" type="button" class="btn btn-primary btn-block">VER DETALLADO (Tickets)</button>
                        <p>&nbsp;</p>
                    </div>                    
                    <div>
                        <a type="button" target="_blank" routerLink="/print-gastos" class="btn btn-success btn-block " mat-button (click)="imprimirGastos()" >IMPRIMIR GASTO {{ codi_edit }}</a>
                        <p>&nbsp;</p>
                    </div>
                    <div>
                        <button *ngIf="estadoGasto != 'PAGADO'" data-toggle="modal" data-target="#modalElimina" data-dismiss="modal" type="button" class="btn btn-danger btn-block">ELIMINAR GASTO</button>
                    </div>
                    <div>
                        <app-loading class="m-5" *ngIf="loading2"></app-loading>
                        <p *ngIf="estadoGasto=='PENDIENTE'">&nbsp;</p>
                        <button *ngIf="estadoGasto=='PENDIENTE'" type="button" class="btn btn-info btn-block" (click)="autorizaGasto()" data-dismiss="modal" >FINALIZAR GASTO (ENVIAR TESORERÍA P/REINTEGRO)</button>
                    </div>            
                </div>

            </div>
            <div class="modal-footer" style="text-align: center; display: block;">
                <button type="button" class="btn btn-secondary btn-block" data-dismiss="modal">Volver</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal CONFIRMAR ELIMINAR GASTO-->
<div class="modal fade" id="modalElimina" tabindex="-1" role="dialog" aria-labelledby="modalElimina" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modito" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Gasto COD [{{ codi_edit }}] - ELIMINAR</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <h5 style="color:dimgray"> "¿Eliminar definitivamente el gasto "{{ det_edit }}"?</h5>
                <hr>
                <div id="tienebotones" style="text-align: center;">
                    <button (click)="eliminarGasto()" style="width: 150px; height: 60px" data-dismiss="modal" type="button" class="btn btn-danger">ELIMINAR GASTO</button>
                </div>
            </div>
            <div class="modal-footer" style="text-align: center; display: block;">
                <button style="width: 150px; height: 60px" type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
            </div>
        </div>
    </div>
</div>


<!-- EMPIEZA FORMULARIO -->
<app-loading class="m-5" *ngIf="loading"></app-loading>
<div class="animated fadeIn" id="todo">
    <div class="col-lg-12">
        <span id="titlee" style="font-weight: bolder;"> Mis gastos</span>
        <form>
            <div class="filters">
                <span>[{{dataSource.data.length}} registros] </span>
            </div>

            <hr>

            <div>
                <label for="gasde">Filtro por Categoría</label>
                <select [(ngModel)]="catcat" name="catcat" id="cate" class="form-control">
                    <option>VIAJE</option>
                    <option *ngIf="(role=='AUTORIZADOR') || (role=='ADMIN')">SECCIONAL</option>
                    <option *ngIf="(role=='AUTORIZADOR') || (role=='ADMIN')" >GASTOS OBRA SOCIAL</option>
                    <option *ngIf="(role=='DELEGADO') || (role=='ADMIN')" >GASTOS DELEGACION</option>
                </select>
            </div>

            <div id="filtrosEstado">
                <label for="gasde">Filtro por estado del gasto</label>
                <select (click)="clickestado()" [(ngModel)]="estadin" name="estadin" id="estadin" class="form-control">
                    <option *ngIf="role!='USER'" value="PENDIENTE" >GUARDADOS</option>
                    <option *ngIf="role=='USER'">PENDIENTE</option>
                    <option value="AUTORIZADO">AUTORIZADO (ENVIADA A TESORERÍA)</option>
                    <option [hidden]="role=='USER'" >PAGADO</option>
                </select>
            </div>
            <br>
            <button (click)="cargarGrid()" type="button" class="btn btn-secondary btn-block" mat-button> CONSULTAR GASTOS</button>

        </form>
        <hr>

        <!-- Button trigger modal 
    <button *ngIf="codi_edit" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal2">
      ver
    </button>
  -->
        <div id="grid" #TABLE>

            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar..">
            </mat-form-field>

            <div class="example-container mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Position Column -->
                    <ng-container matColumnDef="position">
                        <th class="thth" mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                        <td class="thth" mat-cell *matCellDef="let element"> {{element.position}} </td>
                    </ng-container>


                    <ng-container matColumnDef="CODIGO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> CODGAS </th>
                        <td mat-cell *matCellDef="let element"> {{element.CODIGO}} </td>
                    </ng-container>
                    <ng-container matColumnDef="CATEGORIA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> MOTIVO </th>
                        <td mat-cell *matCellDef="let element"> {{element.CATEGORIA}} </td>
                    </ng-container>
                    <ng-container matColumnDef="DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
                        <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element"> {{element.DETALLE}} </td>
                    </ng-container>
                    <ng-container matColumnDef="IMPORTE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> TOTAL </th>
                        <td style="font-weight: bold" mat-cell *matCellDef="let element"> {{element.IMPORTE | currency:"$"}} </td>
                    </ng-container>
                    <ng-container matColumnDef="ESTADO">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTADO </th>
                            <td mat-cell *matCellDef="let element"> {{element.ESTADO}} </td>
                    </ng-container>
                    <ng-container matColumnDef="OBSERVACIONES">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> OBSERVACIONES </th>
                        <td mat-cell *matCellDef="let element"> {{element.OBSERVACIONES}} </td>
                    </ng-container>
                    <ng-container matColumnDef="FECHA_MODIFICACION">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA </th>
                        <td mat-cell *matCellDef="let element"> {{ element.FECHA_MODIFICACION | date:"dd/MM/yy" }} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row (click)="selectRow(row.CODIGO,row.DETALLE,row.IMPORTE,row.ESTADO)" data-toggle="modal" data-target="#exampleModal2" *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
                </table>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

        </div>
        <button class="btn-block" color="dark" mat-button (click)="exportAsExcel()" [disabled]="dataSource.data.length==0">Exportar a Excel</button>
        <button type="button" class="btn btn-secondary btn-block" mat-button routerLink="/home">Volver</button>
    </div>
</div>